export default __webpack_public_path__ + "static/media/bulb.3f4f1f6a.svg";